import {
    useState,
} from 'react';
import { Button, Alert } from 'react-bootstrap';
import { useOutletContext } from 'react-router-dom';
import Loader from '../components/Loader';
import { checkError, getCookie } from '../utils/utils';
import { api } from "../services/config"
import axios from 'axios';


function FilterScreen() {
    const [showError, setShowError] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false)

    const { profileState } = useOutletContext();
    const { projectRole: { projectId } } = profileState


    const onShowSuccessMessage = () => {
        setShowSuccess(true)
        window.setTimeout(() => {
            setShowSuccess(false)
        }, 5000)
    };

    const onShowErrorMessage = () => {
        setShowError(true)
        window.setTimeout(() => {
            setShowError(false)
        }, 5000)
    };

    const csrftoken = getCookie('csrftoken');

    async function onClickButton() {
        setIsLoading(true)
        await axios.post(api.project + projectId + '/filter/', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRFToken': csrftoken
            },
        })
            .then(checkError)
            .then(() => {
                setIsLoading(false)
                onShowSuccessMessage()
                setMessage("Filtrage des termes en cours, veuillez vérifier la page des statuts des tâches")
            })

            .catch((res) => {
                setIsLoading(false)
                onShowErrorMessage();
                console.log(res);
            })

    }

    return (
        <div>

            <div className="container-element">
                <div className="container text-center mt-5">
                    <h4 className="mb-3">Filtre</h4>
                    <Alert className="mx-5" variant="success" show={showSuccess} >
                        La tâche de filtrage a été prise en compte avec succès.
                    </Alert>
                    <Alert className="mx-5" variant="danger" show={showError} >
                        Une erreur s'est produite lors du lancement de la tâche de filtrage.
                    </Alert>
                    {isLoading && <div className="m-2"><Loader>Filtre des termes ...</Loader></div>}
                    <div className="text-center"><Button className="mt-2" onClick={onClickButton} >Filtrer</Button></div>
                    <p className="m-2  mt-4">{message}</p>
                </div>
            </div>
        </div >
    )
}

export default FilterScreen
